import { Injectable } from '@angular/core';
import { Headers, Http, Response, RequestOptions } from '@angular/http';

import 'rxjs/add/operator/toPromise';

import {apiUrl} from './global';
import { ResponseApi } from './response-api';

@Injectable()
export class ValidateEmailService {
  private url = apiUrl;  // URL to web api

  constructor(private http: Http) { }

  getHash(hash: string): Promise<ResponseApi[]> {
    return this.http
      .get(this.url + 'validate-email/' + hash)
      .toPromise()
      .then(response => response.json() as ResponseApi[])
      .catch(this.handleError);
  }

  postAuthenticate(url: string, firstName:string, lastName:string, identifier:string): Promise<ResponseApi[]> {
    let body = JSON.stringify({ url:url, firstName: firstName, lastName:lastName, identifier: identifier});
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    return this.http
      .post(this.url + 'authenticate-user-first-time', body, options)
      .toPromise()
      .then(response => response.json() as ResponseApi[])
      .catch(this.handleError);
  }

  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error);
    return Promise.reject(error.message || error);
  }
}



// WEBPACK FOOTER //
// /Users/mosheborochov/Desktop/work/QCEV/dev/QCEV-FRONT/src/app/validate-email.service.ts